import React from "react";

import CmsPreviewShell from "./CmsPreviewShell";
import mockData from "./mockData.json";

import type { CmsComponentProps, InstructorMock } from "./types";

const InstructorComponent: React.FC<CmsComponentProps> = ({ title, layout, items: userItems }) => {
  const items: InstructorMock[] =
    userItems && userItems.length > 0
      ? userItems
          .filter((i) => i.is_active !== false)
          .map((i, idx) => ({
            id: idx,
            title: i.title,
            description: i.description ?? "",
            img: i.img ?? "",
            brandName: i.brand_name ?? "",
            sports: i.sports ?? [],
            certificates: i.certificates ?? [],
          }))
      : (mockData.instructor as InstructorMock[]);

  return (
    <CmsPreviewShell title={title}>
      <div className={`cms-instructor cms-instructor--${layout}`}>
        {items.map((item) => (
          <div key={item.id} className="cms-instructor__item">
            <div className="cms-instructor__avatar">{item.img ? <img src={item.img} alt={item.title} /> : <div className="cms-instructor__placeholder">이미지 없음</div>}</div>
            <div className="cms-instructor__body">
              <div className="cms-instructor__head">
                <h5 className="cms-instructor__name">{item.title}</h5>
                {item.brandName && <span className="cms-instructor__brand">{item.brandName}</span>}
              </div>
              {item.description && <p className="cms-instructor__desc">{item.description}</p>}
              <div className="cms-instructor__chips">
                {item.sports.map((s) => (
                  <span key={s} className="cms-instructor__chip cms-instructor__chip--sport">
                    {s}
                  </span>
                ))}
                {item.certificates.slice(0, 2).map((c) => (
                  <span key={c} className="cms-instructor__chip cms-instructor__chip--cert">
                    {c}
                  </span>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </CmsPreviewShell>
  );
};

export default InstructorComponent;
